import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { navigateWithFreshRoute } from 'src/app/shared/route-reuse.util';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CreditModelComponent } from 'src/app/components/credit/credit-model/credit-model.component';
import { PricePlanService } from 'src/app/components/Price-subscritions/priceplanService';
import { countProvider, WIDGET_DATA } from 'src/app/components/suggestions/suggestions.component';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { CandidateService } from 'src/app/services/CandidateService';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from 'src/app/services/util.service';
import { CommonModule } from '@angular/common';
import { CommonSkeletonComponent } from 'src/app/skeleton/common-skeleton/common-skeleton.component';
import { CommonProfileInfoComponent } from 'src/app/widget/common-profile-info/common-profile-info.component';
import { CandidateCardComponent } from 'src/app/components/cards/candidate-card/candidate-card.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-candidate-you-might-be-intrested-in',
  standalone: true,
  imports: [
    CommonModule,
    CommonSkeletonComponent,
    CommonProfileInfoComponent,
CandidateCardComponent,
    InfiniteScrollModule
  ,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './candidate-you-might-be-intrested-in.component.html',
  styleUrls: ['./candidate-you-might-be-intrested-in.component.scss']
})
export class CandidateYouMightBeIntrestedInComponent implements OnInit, OnChanges {

  @Input('title') title: string = 'Candidates from Connections';
  @Input() widgetDesc: string;
  @Input() suggestion: any;

  headerTitle: string = 'Candidates from Connections';
  user: any = [{ a: 1 }, { a: 2 }, { a: 3 }, { a: 4 }];
  userType: any = localStorage.getItem('userType');
  candidatefilter
  response: any = [];
  totalCount: any;
  sugges = null
  @Input() inputData: string;
  @Input() page: string;
  configlist = {
    itemsPerPage: 5,
    currentPage: 1
  }
  pathdata: any;
  stopScroll : boolean = false;
  @Input() maxMin: any = {};
  viewType: string = "MIN";
  candidateCount: any;
  prevAfterkey : string = "";
  bsModalRef: BsModalRef;
  loadAPIcall:boolean=false;
   params: any = {
    limit: 10,
    pageNumber: 0,
    createdBy: localStorage.getItem('userId'),
    searchAfterKey: null
  }

  constructor(private a_route: ActivatedRoute, private planService: PricePlanService, private modalService: BsModalService,
    private searchdata: SearchData, private router: Router, private apiService: ApiService, private provider : countProvider,
    private candidateService: CandidateService, private util: UtilService,
    @Optional() @Inject(WIDGET_DATA) private widgetData: any) {
    // Apply injected widget data (Angular 15 NgComponentOutlet pattern)
    if (this.widgetData) {
      if (this.widgetData.maxMin) {
        this.maxMin = this.widgetData.maxMin;
        if (this.widgetData.maxMin.viewType) {
          this.viewType = this.widgetData.maxMin.viewType;
        }
      }
      if (this.widgetData.widgetDesc) {
        this.headerTitle = this.widgetData.widgetDesc;
      }
      if (this.widgetData.inputData) {
        this.inputData = this.widgetData.inputData;
      }
      if (this.widgetData.page !== undefined) {
        this.page = this.widgetData.page;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle maxMin changes - critical for showing MAX view on suggestions page
    if (changes.maxMin) {
      const newMaxMin = changes.maxMin.currentValue;
      if (newMaxMin) {
        this.maxMin = newMaxMin;
        if (newMaxMin.viewType) {
          this.viewType = newMaxMin.viewType;
        }
      }
    }
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  click: boolean
  ngOnInit() {
    this.searchdata.getWidget().subscribe(res => {
      this.click = res
    })
    this.userType = localStorage.getItem('userType');
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }

    this.a_route.queryParams.subscribe((res) => {

      if (res.singleCandiY == "true") {
        this.getSingleCandi(res.id, false)
      } else {
        this.candidateApi()
      }

      this.candidatefilter = res.jobfilter;

      if (res.master != "NETWORK" && res.master != "TEAM" && res.menu != null && res.menu != undefined) {
        this.headerTitle = res.menu;
      }

      if (this.maxMin.viewType != undefined) {
        this.viewType = "MAX";
        this.inputData = this.maxMin.master;
      }

    })
    var a = this.a_route.pathFromRoot[0]['_routerState']['snapshot'].url
    var b = a.substring(0, 20)
    if (b == '/newcandidates?jobId') {
      this.candidatefilter = "true";
    } if (b == '/newjobs?candidateId') {
      this.candidatefilter = "true";
    }

  }
  onScrollDown(){
    if (!this.stopScroll && this.params.searchAfterKey != this.prevAfterkey) {
      this.params.searchAfterKey = this.prevAfterkey === null ? null
      : this.prevAfterkey;
      this.candidateApi();
    }
  }

  openModalWithComponent() {

    const initialState: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "open"
    };
    this.bsModalRef = this.modalService.show(CreditModelComponent, initialState);


  }


  modelopen(data, show, candiid) {
    let dataPass: any = {};
    dataPass.data = data;
    dataPass.id = candiid;
    dataPass.singleCandiY = show;
    dataPass.menu = this.headerTitle || this.widgetDesc || 'Candidates from Connections';
    dataPass.master = this.page;
    dataPass.masterMenu = this.inputData;
    dataPass.widgetName = "CandidateYouMightBeIntrestedInComponent";
    dataPass.count = this.totalCount;
    this.router.navigate(['suggestions'], { queryParams: dataPass })
  }

  async redirect(val) {
    // Route reuse is disabled per-navigation inside navigateWithFreshRoute; the
    // old inline override here leaked to the whole session.
    if (val.createdBy != localStorage.getItem("userId") && val.isViewed == false &&
      this.userType != "JOB_SEEKER") {
      // const userData = await this.planService.UPDATE_USERDETAILS("RESUME_VIEWS");
      // if (userData.isExpired) {
      //   let availablePoints = null;
      //   let actualPoints = null;
      //   let utilizedPoints = null;
      //   userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
      //     if (ele.benefitKey == 'RESUME_VIEWS') {
      //       availablePoints = ele.available
      //       actualPoints = ele.actual
      //       utilizedPoints = ele.utilized
      //     }
      //   })
      //   this.planService.expiredPopup("RESUME_VIEWS", "PAY", null, null, null, availablePoints, actualPoints, utilizedPoints);

      //   return;
      //} else {
        this.updateView(val);
     // }
    } else {
      navigateWithFreshRoute(this.router, ['newcandidates'], { queryParams: { candidateId: val.candidateId, tabName: 'profileSummary', From: 'CANDIDATES_FROM_CONNECTION' } })
    }

  }

  updateView(val) {
    this.util.startLoader();
    this.candidateService.updateCandidateViewed(val)
      .subscribe(
        (res) => {
          this.util.stopLoader();
          if (res.code === "00000") {
            navigateWithFreshRoute(this.router, ['newcandidates'], { queryParams: { candidateId: val.candidateId, tabName: 'profileSummary', From: 'CANDIDATES_FROM_CONNECTION' } })
          }
        },
        (err) => {
          this.util.stopLoader();
        }
      );
  }

  refreshCandidate() {
    this.params.searchAfterKey=null
    this.candidateApi();
  }

  resultContent: string = "";
  totalcandidates: number = 10;

  candidateApi() {

    this.loadAPIcall=true;
    this.apiService.create("candidates/findCandidateYouMayInterested", this.params).subscribe((res) => {
      this.loadAPIcall=false;

         if (res != null && res.data != null) {
            const resData = res.data.candidateList;
            const afterKey = res.data.searchAfterKey && res.data.searchAfterKey;
            if(resData){
              if(this.prevAfterkey === afterKey || resData.length === 0){
                this.stopScroll = true;
              }

              if (resData === null || resData.length === 0) {
                this.resultContent = "NULL";
              } else {
                const tempResponse = resData.map(ele => ({
                  ...ele,
                  user: {
                    ...ele.user,
                    photo: ele.user.photo != null ? AppSettings.photoUrl + ele.user.photo : null
                  }
                }));
                if (this.params.searchAfterKey == null) {
                  this.response = [];
                }
                this.response = this.response.concat(tempResponse); // Concatenate new data to existing data

              }
              this.prevAfterkey = afterKey;

            }
            if (res.data.totalCandidates != undefined && res.data.totalCandidates != 0) {
              this.totalcandidates = res.data.totalCandidates;
              this.candidateCount = res.data.totalCandidates;
              this.provider.setCount(this.candidateCount , "CandidateYouMightBeIntrestedInComponent");
            }
      }

    }, (error) => {
      this.loadAPIcall = false;
    })
  }

  currentPage: Number;
  pagecount(event) {

    this.configlist.currentPage = event;
    this.page = event;
    this.currentPage = event - 1
    this.params.pageNumber= this.currentPage;
    this.candidateApi();
  }

  getSingleCandi(candiId, clickable) {
    if (candiId != null) {
      this.apiService.query("candidates/findCandidateById/" + candiId).subscribe((res) => {
        this.sugges = res.data.candidateData;
        if (clickable && this.click == true) {
          this.modelopen(this.sugges, true, candiId)
        }
      });

    }
  }
}
